<template>
  <div>
    <v-row
      dense
    >
      <v-col>
        <validation-provider
          v-slot="{ errors }"
        >
          <number-input
            v-model="dirtySetParams.NMRP"
            outlined
            dense
            :label="$t('training_builder.text_input.no_of_repetitions.title')"
            :placeholder="$t('label.e_g') + ' ' + 10"
            :decimal-precision="0"
            :error-messages="errors"
          />
        </validation-provider>
      </v-col>
      <v-col>
        <validation-provider
          v-slot="{ errors }"
        >
          <number-input
            v-model="dirtySetParams.WRPRDR"
            outlined
            dense
            :label="$t('training_builder.text_input.working_period.title')"
            :placeholder="$t('label.e_g') + ' ' + 30"
            suffix="s"
            :decimal-precision="0"
            :error-messages="errors"
          />
        </validation-provider>
      </v-col>
      <v-col>
        <validation-provider
          v-slot="{ errors }"
        >
          <number-input
            v-model="dirtySetParams.RSPRDR"
            outlined
            dense
            :label="$t('training_builder.text_input.resting_period.title')"
            :placeholder="$t('label.e_g') + ' ' + 30"
            suffix="s"
            :decimal-precision="0"
            :error-messages="errors"
          />
        </validation-provider>
      </v-col>
    </v-row>

    <v-divider class="mb-6" />

    <v-row dense>
      <v-col cols="6">
        <minute-second-input
          :value="dirtySetParams.RSSTDR"
          :label="$t('training_builder.text_input.rest_time_after_set')"
          variable="RSSTDR"
          @input="handleDurationInput"
        />
      </v-col>
    </v-row>

    <v-divider class="mb-6" />

    <v-row dense>
      <v-col>
        <validation-provider
          v-slot="{ errors }"
        >
          <number-input
            v-model="dirtySetParams.NMST"
            outlined
            :label="$t('training_builder.text_input.no_of_stations.title')"
            :placeholder="$t('label.e_g') + ' ' + 5"
            dense
            :decimal-precision="0"
            :error-messages="errors"
          />
        </validation-provider>
      </v-col>
      <v-col>
        <validation-provider
          v-slot="{ errors }"
        >
          <number-input
            v-model="dirtySetParams.PLST"
            outlined
            dense
            :label="$t('training_builder.text_input.players_on_station.title')"
            :placeholder="$t('label.e_g') + ' ' + 10"
            :decimal-precision="0"
            :error-messages="errors"
          />
        </validation-provider>
      </v-col>
      <v-col>
        <validation-provider
          v-slot="{ errors }"
        >
          <number-input
            v-model="dirtySetParams.DMS1"
            outlined
            dense
            :label="$t('training_builder.text_input.dimension.title')"
            :placeholder="$t('label.e_g') + ' ' + 20"
            suffix="m"
            :decimal-precision="1"
            :error-messages="errors"
          />
        </validation-provider>
      </v-col>
      <v-col>
        <validation-provider
          v-slot="{ errors }"
        >
          <number-input
            v-model="dirtySetParams.DMS2"
            outlined
            dense
            :label="$t('training_builder.text_input.dimension.title')"
            :placeholder="$t('label.e_g') + ' ' + 20"
            suffix="m"
            :decimal-precision="1"
            :error-messages="errors"
          />
        </validation-provider>
      </v-col>
    </v-row>

    <v-divider class="mb-6" />

    <v-row dense>
      <v-col cols="3">
        <div class="text-body-1 mb-2">
          {{ $t('training_builder.dropdown.terrain.title') }}
        </div>
        <validation-provider
          v-slot="{ errors }"
        >
          <v-select
            v-model="dirtySetParams.TRRN"
            outlined
            dense
            :placeholder="$t('training_builder.dropdown.terrain.placeholder')"
            :error-messages="errors"
            :items="[ { text: $t('training_builder.dropdown.terrain.item.grass'), value: 'Grass' }, { text: $t('training_builder.dropdown.terrain.item.artificial_grass'), value: 'Artificial grass' }, { text: $t('training_builder.dropdown.terrain.item.hybrid_grass'), value: 'Hybrid grass' }, { text: $t('training_builder.dropdown.terrain.item.parquet'), value: 'Parquet' }, { text: $t('training_builder.dropdown.terrain.item.concrete'), value: 'Concrete' }, { text: $t('training_builder.dropdown.terrain.item.sand'), value: 'Sand' }, ]"
          />
        </validation-provider>
      </v-col>
      <v-col cols="3">
        <div class="text-body-1 mb-2">
          {{ $t('training_builder.dropdown.goal.title') }}
        </div>
        <validation-provider
          v-slot="{ errors }"
        >
          <v-select
            v-model="dirtySetParams.GOAL"
            outlined
            dense
            :placeholder="$t('training_builder.dropdown.goal.placeholder')"
            :error-messages="errors"
            :items="[ { text: $t('training_builder.dropdown.goal.item.no_goal'), value: 'No goal' }, { text: $t('training_builder.dropdown.goal.item.big_goal'), value: 'Big goal' }, { text: $t('training_builder.dropdown.goal.item.small_goal'), value: 'Small goal' } ]"
          />
        </validation-provider>
      </v-col>
      <v-col cols="3">
        <div class="text-body-1 mb-2">
          {{ $t('training_builder.dropdown.joker.title') }}
        </div>
        <validation-provider
          v-slot="{ errors }"
        >
          <v-select
            v-model="dirtySetParams.JKR"
            outlined
            dense
            :placeholder="$t('training_builder.dropdown.joker.placeholder')"
            :error-messages="errors"
            :items="[ { text: $t('training_builder.rm.no'), value: false }, { text: $t('training_builder.rm.yes'), value: true } ]"
          />
        </validation-provider>
      </v-col>
      <v-col
        v-if="dirtySetParams.JKR === true"
        cols="3"
      >
        <div class="text-body-1 mb-2">
          {{ $t('training_builder.dropdown.joker.how_many') }}
        </div>
        <validation-provider
          v-slot="{ errors }"
        >
          <number-input
            v-model="dirtySetParams.JKRNR"
            outlined
            dense
            :placeholder="$t('label.e_g') + ' ' + 2"
            :decimal-precision="0"
            :error-messages="errors"
          />
        </validation-provider>
      </v-col>
    </v-row>

    <v-divider class="mb-6" />

    <v-row dense>
      <v-col cols="3">
        <validation-provider
          v-slot="{ errors }"
        >
          <number-input
            v-model="dirtySetParams.NMCNT"
            outlined
            :label="$t('training_builder.text_input.no_of_contacts.title')"
            :placeholder="$t('label.e_g') + ' ' + 25"
            dense
            :decimal-precision="0"
            :error-messages="errors"
          />
        </validation-provider>
      </v-col>
    </v-row>

    <v-divider
      v-if="exercise.drill && user.organisation_settings && user.organisation_settings.has_drill_module"
      class="mb-4"
    />

    <v-card
      v-if="exercise.drill && user.organisation_settings && user.organisation_settings.has_drill_module"
      outlined
      class="mb-4 elevation-0 grey lighten-4"
    >
      <v-row>
        <v-col>
          <v-img
            :src="exercise.drill.preview"
            class="ma-3"
            width="200"
            contain
          />
        </v-col>
        <v-col>
          <v-row class="flex-column mt-2">
            <v-col>
              <span class="font-weight-bold">
                {{ exercise.drill.name }}
              </span>
            </v-col>
            <v-col>
              <div
                class="caption mb-3"
                style="-webkit-line-clamp: 4; -webkit-box-orient: vertical; display: -webkit-box; overflow: hidden; width: 100%"
              >
                {{ exercise.drill.description }}
              </div>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="auto">
          <v-btn
            text
            small
            color="primary"
            class="text-none mr-2 mt-2"
            @click="editDrill = true"
          >
            <v-icon
              left
              small
            >
              far fa-pen
            </v-icon>
            Edit for this protocol
          </v-btn>
        </v-col>
      </v-row>
    </v-card>

    <v-divider class="mb-6" />

    <div class="text-body-1">
      {{ $t('training_builder.slider.effort_level.title') }}
    </div>
    <validation-provider>
      <v-slider
        v-model="dirtySetParams.EFFRT"
        color="primary"
        thumb-color="primary"
        track-color="grey"
        thumb-label="always"
        ticks="always"
        :step="1"
        :tick-size="4"
        :min="1"
        :max="10"
        dark
        class="pt-12"
      />
    </validation-provider>

    <card-dialog
      v-if="exercise.drill"
      :key="'Edit drill' + componentKey"
      v-model="editDrill"
      :title="$t('card_dialog.edit_drill.title')"
      :scrollable="false"
      fullscreen
      persistent
    >
      <v-card-text>
        <div
          style="height: 2px"
        >
          <v-progress-linear
            v-if="submitting"
            indeterminate
            color="primary"
            :height="2"
          />
        </div>
        <HomeView
          :drill="exercise.drill"
          :sport="user.sport.name"
          :players="players.data"
          :teams="teams"
          @save="handleDrillEdit"
        />
      </v-card-text>
    </card-dialog>
  </div>
</template>

<script>
import NumberInput from '@/components/helpers/NumberInput.vue'
import { cloneVariables } from '@/components/training-builder/helpers'
import MinuteSecondInput from '@/components/helpers/MinuteSecondInput.vue'
import CardDialog from '@/components/helpers/CardDialog.vue'
import { PlayerApiService } from '@/data/services'
import HomeView from '@ultrax-ai/drill-package'
import { DrillApiService } from '@/data/services/DrillApiService'
import { EventBus } from '@/plugins/bus'

export default {
  name: 'FootballParamsEntry',
  components: { CardDialog, MinuteSecondInput, NumberInput, HomeView },
  props: {
    exercise: {
      type: Object,
      required: true
    },
    setParams: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      dirtySetParams: cloneVariables(this.setParams),
      editDrill: false,
      players: {
        data: [],
        loading: false
      },
      submitting: false,
      componentKey: 1
    }
  },
  computed: {
    user() {
      return this.$store.getters[this.$storeGetters.AUTH_USER]
    },
    teams() {
      return this.$store.getters[this.$storeGetters.APP_TEAMS]
    }
  },
  watch: {
    dirtySetParams: {
      deep: true,
      handler: function (newValue) {
        this.$emit('update:setParams', newValue)
      }
    },
    editDrill: function (val, oldVal) {
      if (val) this.componentKey++
    }
  },
  mounted() {
    this.fetchPlayers()
  },
  methods: {
    checkIfParamExists(param) {
      if (!this.exercise.tags) return false

      return this.exercise.tags.some(t => t.tag_id === 'params' && t.value === param)
    },
    handleDurationInput(min, sec, variable) {
      this.dirtySetParams[variable] = min * 60 + sec > 0 ? min * 60 + sec : null
    },
    async fetchPlayers() {
      try {
        this.players.loading = true

        const resp = await PlayerApiService.getSimpleList({})

        this.players.data = resp.data
      } catch (e) {
        this.players.data = []
      } finally {
        this.players.loading = false
      }
    },
    async handleDrillEdit(saveData) {
      try {
        this.submitting = true

        const data = {
          name: saveData.name,
          description: saveData.description,
          preview: saveData.preview,
          state: saveData.state,
          coach_id: this.user.coach.id,
          team_ids: saveData.team_ids,
          player_ids: saveData.player_ids,
          is_hidden: true,
          tags: saveData.tags
        }

        const result = await DrillApiService.create(data)

        this.exercise.drill = result.data
        this.editDrill = false

        EventBus.$emit(this.$events.DRILL_CREATED)
      } catch (e) {
        this.$store.dispatch(this.$storeActions.ALERT, {
          text: this.$t('alert.drill_save.error'),
          color: 'error'
        })
        throw e
      } finally {
        this.submitting = false
      }
    }
  }
}
</script>
